<script setup lang="ts">
import { useMaterialComposable } from '@/components/materials/composable/useMaterialComposable'
import { ChoiceField, HelpTextTooltip, TextField } from '@haskoning/vue-component-library'

const { materialStore, currentItem, hasHelpText } = useMaterialComposable()

const concreteElementFields = ['concrete_density', 'angle_repose_concrete']
</script>

<template>
  <v-card elevation="0" flat>
    <v-card-title class="header-font"> Concrete elements</v-card-title>
    <v-card-subtitle class="description-font">
      Define the material conditions that will applied to all calculations in your project.
    </v-card-subtitle>

    <v-card-text>
      <span class="sub-header-font">
        Please select which concrete elements will apply for your project:
      </span>
      <v-row class="pt-2" align="center" no-gutters>
        <v-col cols="12" md="8" lg="4">
          <ChoiceField
            :field="materialStore.fields.concrete_element_type"
            :model-value="currentItem"
            :no-help-text="true"
            :readonly="!materialStore.canChangeMaterial"
            @update="materialStore.update(currentItem)"
          />
        </v-col>
      </v-row>

      <span class="sub-header-font"> Material densities </span>
      <v-row align="center" no-gutters v-for="field in concreteElementFields" :key="field">
        <v-col cols="12" md="8" lg="4" class="d-flex align-center">
          <HelpTextTooltip
            v-if="hasHelpText(field)"
            :text="materialStore.fields[field].help_text || ''"
          />
          <span :class="hasHelpText(field) ? 'px-2' : 'px-0'">
            {{ materialStore.fields[field].label }}
          </span>
        </v-col>

        <v-col cols="12" md="8" lg="4" class="pt-0">
          <TextField
            :field="materialStore.fields[field]"
            :model-value="currentItem"
            :no-help-text="true"
            :readonly="!materialStore.canChangeMaterial"
            @update="materialStore.update(currentItem)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
